<template>
  <div class="profile bg-white">
    <div class="mt-5 pt-5 kovatek-width container-fluid">
      <div class="row mt-4">
        <div class="col-6 col-lg-8">
          <div class="row px-2 px-md-4 px-lg-5">
            <div class="col-12 col-md-4 col-lg-3 text-right">
              <img
                :src="
                  talent.Setting.AvatarHref
                    ? talent.Setting.AvatarHref
                    : talentImg
                "
                alt
                class="rounded-circle img-height"
              />
              <h3
                class="text-center center mt-3 font-weight-bolder kova-text ctrl-heading"
                style="font-size: 20px"
              >
                {{ talent.Setting.Username }}
              </h3>
            </div>
            <div class="col-12 col-md-8 ml-3 px-0">
              <h3
                class="text-left center font-weight-bolder kova-text ctrl-heading"
                style="font-size: 20px"
              >
                {{ talent.Speciality }}
                <img
                  class="ml-1 ml-md-2 mb-1"
                  style="height:22px;"
                  src="../assets/kovatek/correct.svg"
                  alt
                />
              </h3>
              <!--               <h5
                class="text-left center mb-1 ctrl-heading1"
                style="font-size: 13px"
              >
                {{talent.Speciality}}
              </h5> -->
              <p
                class="text-uppercase center text-left mb-0 text-intermediate ctrl-heading3"
                style="font-size: 13px"
              >
                {{ computeLevel(talent.SeniorityLevel) }}
              </p>

              <div class="text-left center mt-3">
                <span
                  class="text-size1 font-weight-bolder"
                  style="font-size: 13px"
                  >$30</span
                >/hr
                <span class="text-size2 text-left" style="font-size: 13px">
                  <font-awesome-icon
                    style="font-size: 13px;"
                    icon="map-marker-alt"
                    class="text-dark ml-2 ml-md-3 mr-2"
                  ></font-awesome-icon
                  >{{ talent.City }}, {{ talent.Country }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-4">
          <div class="text-right seconddiv mr-5">
            <span class>
              <img
                class="mr-1 mr-md-2 star"
                src="../assets/kovatek/best.svg"
                alt
              />
              <span
                class="font-weight-bolder text-size rating"
                style="font-size: 30px"
                >9.5</span
              >
              <span class="ml-1 ctrl-size-2">56 reviews</span>
            </span>

            <h5
              class="text-right mb-1 ctrl-heading1"
              style="font-size: 13px; margin-top: 31px;"
            >
              Jobs Completed: 4
            </h5>
            <h5 class="text-right mb-1 ctrl-heading1" style="font-size: 13px">
              Team work: 4
            </h5>
            <!-- <div class="mt-lg-4">
                                <button class="programming-task px-4 px-md-5 py-2 text-size2">Programming Task</button>
            </div>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 px-md-5">
          <Profiles :talent="talent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Profiles from "@/components/Profiles.vue";
import { computeExperienceLevel } from "@/helpers/compute.js";
import user from "../assets/user.png";
export default {
  name: "profile",
  components: {
    Profiles,
  },
  props: {
    talent: { type: Object },
  },
  data() {
    return {
      talentImg: user,
      generalSkills: [
        {
          name: "PHP",
          level: "(Expert)",
          frameworks: "Laravel, Lumen, Symphony",
        },
        {
          name: "Database",
          level: "(Advance)",
          frameworks: "Mysql, Postgress, Database Design",
        },
        {
          name: "Nodejs",
          level: "(Advance)",
          frameworks: "ExpressJS, Lambda AWS",
        },
        {
          name: "Javascript",
          level: "(Advance)",
          frameworks: "jQuery,VueJS, extJS",
        },
        {
          name: "Golang",
          level: "(Advance)",
          frameworks: "Http, Gin, Chi, Gorm",
        },
        {
          name: "CI/CD",
          level: "",
          frameworks: "docker,travis,gitlab,circleci",
        },
        {
          name: "Project Management",
          level: "",
          frameworks: "Jira,Github,Gitlab,Bitbucket",
        },
      ],
      feExperience: [
        "Vanilla JavaScript",
        "ExtJS dev (Version 3-6)",
        "Classic Jquery development",
        "VueJS",
      ],
      feSkills: ["JSON", "Jquery", "VueJS", "JavaScript", "SQL", "Git", "HTML"],
      beExperience: [
        "API development with Laravel",
        " Third API integration",
        "Express NodeJS API development",
        "Design Relational Tables Database",
        "SQL with MySQL",
        "Lambda aws (NodeJS)",
        "API database driven development with Golang Mux Router /Gin/ Chi Framework",
        "Basic ElasticSearch integration",
      ],
      beSkills: ["PHP", "Database", "Backend RESTful APIs", "Nodejs", "Golang"],
      skills: [
        "Laravel Framework",
        "Nodejs",
        "Golang",
        "jQuery",
        "JavaScript",
        "database",
        "Modeling",
        "Vue.js",
        "Express.js",
        "Ext JS",
        "Docker",
      ],
      workHistory: [
        {
          title: "PHP / extJS / MVC Application Update",
          duration: " Mar 2016 - Sep 2018",
          star: 5,
          comment: "Solid experience with PHP and extJS. Good quality work.",
          earned: 963.34,
          earnedPerHour: 20.0,
          hours: 48,
        },
        {
          title: "ExtJS prototype development",
          duration: "Jul 2016 - Aug 2016",
          star: 5,
          comment: "Nice job, completed on-time and high quality.",
          earned: 560.0,
          earnedPerHour: 30.0,
          hours: 19,
        },
      ],
    };
  },
  methods: {
    computeLevel(level) {
      return computeExperienceLevel(level);
    },
  },
};
</script>

<style scoped>
.bg-kovatek {
  background-color: #20409a;
}
.btn-kovatek {
  background-color: #20409a;
  height: 50px;
  color: #fff;
  transition: 0.25s;
}
.btn-kovatek:hover {
  background-color: #06216d;
  color: #fff;
}
.input-height {
  height: 50px;
  font-size: 13px;
  width: 100%;
}
.submit-w {
  width: 300px;
}
.add-rounded {
  border-radius: 20px;
}
.img-height {
  max-width: 97px;
  height: 97px;
}
.text-intermediate {
  color: #bdbd50;
}
.text-size {
  font-size: 2.5em;
}
.text-size1 {
  font-size: 20px;
}
.text-size2 {
  font-size: 16px;
}
.text-size3 {
  font-size: 13px;
}
.see-more {
  background-color: transparent;
  border: solid 1.5px #fff;
  border-radius: 20px;
  color: #fff;
  transition: 0.25s;
}
.see-more:hover {
  background-color: #fff;
  color: #20409a;
}
.rating {
  color: #4bb38e;
}
.star {
  position: relative;
  bottom: 10px;
  height: 25px;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
  .cont-size {
    width: 600px;
  }
  .img-height {
    width: 120px;
    height: 120px;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .cont-size {
    width: 600px;
  }
  .img-height {
    width: 120px;
    height: 120px;
  }
}

@media screen and (max-width: 767px) {
  .img-height {
    width: 115px;
    height: 115px;
  }
  .text-size {
    font-size: 1.8em;
  }
  .text-size2 {
    font-size: 16px;
  }
  .ctrl-heading {
    font-size: 1.4em;
  }
  .ctrl-heading1 {
    font-size: 1.2em;
  }
  .ctrl-heading2 {
    font-size: 0.9em;
  }
  .star {
    position: relative;
    bottom: 5px;
    height: 18px;
  }
}

@media screen and (max-width: 450px) {
  .cont-size {
    width: 100%;
  }

  .text-size2 {
    font-size: 12px;
  }
  .img-height {
    width: 85px;
    height: 85px;
  }
  .seconddiv {
    margin-right: 1px !important;
  }
  .rounded-circle {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .center {
    text-align: center !important;
  }
}
@media screen and (max-width: 800px) {
  .submit-w {
    width: 300px !important;
  }
}
</style>
